import { usePageThumbnailUrl } from 'features/knowledgeDocumentViewer/hooks/usePageThumbnailUrl'

import {
  PageLabel,
  ThumbnailImage,
  ThumbnailImageContainer,
  ThumbnailItemWrapper,
  ThumbnailSkeleton,
} from './pageThumbnailSidebarStyles'

interface PageThumbnailItemProps {
  documentId: string
  pageNumber: number
  isActive: boolean
  onClick: (pageNumber: number) => void
  pdfUrl?: string
  totalPages?: number
}

export function PageThumbnailItem({
  documentId,
  pageNumber,
  isActive,
  onClick,
  pdfUrl,
  totalPages,
}: PageThumbnailItemProps) {
  const { url, isLoading } = usePageThumbnailUrl(
    documentId,
    pageNumber,
    pdfUrl,
    totalPages
  )

  return (
    <ThumbnailItemWrapper
      $isActive={isActive}
      onClick={(e) => {
        onClick(pageNumber)
        e.currentTarget.blur()
      }}
      title={`Go to page ${pageNumber}`}>
      <ThumbnailImageContainer $isActive={isActive}>
        {isLoading || !url ? (
          <ThumbnailSkeleton />
        ) : (
          <ThumbnailImage src={url} alt={`Page ${pageNumber}`} loading='lazy' />
        )}
      </ThumbnailImageContainer>
      <PageLabel $isActive={isActive}>{pageNumber}</PageLabel>
    </ThumbnailItemWrapper>
  )
}
